// src/components/Ico.tsx
// Draws a lucide-react icon passed as data (nav items, stat cards, status
// maps), sized to the surrounding text unless a className says otherwise.

import type { LucideIcon } from "lucide-react";

export default function Ico({ icon: Icon, className = "h-[1em] w-[1em]" }: { icon: LucideIcon; className?: string }) {
  return <Icon className={className} aria-hidden />;
}
